import { useEffect, useState } from 'react';
import { getNativeClientIdentity } from '@/lib/pwa/app-data';
import { getClientContext } from './client';

/** Hydrate the server style unchanged, then adopt the synchronized native theme. */
export function ClientThemeStyle({ initialCss }: { initialCss?: string }) {
	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => setIsMounted(true), []);
	const css =
		isMounted && getNativeClientIdentity()
			? getClientContext()._theme?.style
			: initialCss;
	return css ? (
		<style id="app-theme" type="text/css">
			{css}
		</style>
	) : null;
}
